// extracted by css-extract-rspack-plugin
export default {"dialog":"VwlYB3569fojSiyp","list":"ASF6H8Ll5zUvs1ue"};